import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG, CFG_FONT, CFG_GRADIENTS } from '../../theme/configurator-tokens';
import { asset } from './lib/asset';

/**
 * Full-bleed root for the wizard. Owns the whole viewport (no account chrome)
 * and seeds the Satoshi font + dark page background the rest of the area inherits.
 *
 * The viewport background mirrors the Spark configurator (v2): a subtle 4K texture
 * darkened by a centre→edge vignette. The chrome above is translucent, so the image
 * shows through on every step (the WizardLayout shell is transparent).
 */
export const Root = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1;
  overflow: hidden;
  background-color: ${CFG.pageBg};
  background-image: ${CFG_GRADIENTS.pageVignette}, url('${asset('config-bg-4k.jpg')}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: ${CFG.text};
  font-family: ${CFG_FONT};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* Light theme: the dark 4K cinematic texture has no light counterpart, so drop
   * the photo layer entirely and let the wizard sit on the soft light page
   * (background-color = CFG.pageBg → #f5f6f8) under just the light vignette
   * (CFG_GRADIENTS.pageVignette, light-overridden). Token-only values keep the
   * nova strict gate happy. */
  :root[data-ows-theme='light'] & {
    background-image: ${CFG_GRADIENTS.pageVignette};
  }
`;

export const ErrorScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  /* Dynamic viewport height (see the wizard Shell) so the centred error copy stays
     within the visible area on iPad/iOS Safari rather than behind the browser chrome. */
  height: 100dvh;
  width: 100%;
  text-align: center;
  padding: 24px;
`;

export const ErrorTitle = styled(Text)`
  font-size: 18px;
  font-weight: 800;
  color: ${CFG.text};
`;

export const ErrorBody = styled(Text)`
  font-size: 14px;
  color: ${CFG.textMuted};
  max-width: 320px;
`;
